import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalComponent} from './modal.component';
import {MatBottomSheetModule} from "@angular/material/bottom-sheet";
import {AppBarModule} from "@app/presentation/components/app-bar/app-bar.module";
import {ButtonModule} from "@app/presentation/components/button/button.module";
import {TranslateModule} from "@ngx-translate/core";
import {ModalService} from "@app/presentation/services/modal/modal.service";

@NgModule({
  declarations: [
    ModalComponent
  ],
  imports: [
    CommonModule,
    MatBottomSheetModule,
    AppBarModule,
    ButtonModule,
    TranslateModule
  ],
  providers: [
    ModalService
  ]
})
export class ModalModule { }
